import { render } from "./video-placeholder.vue?vue&type=template&id=18aff0a4"
import script from "./video-placeholder.vue?vue&type=script&lang=js"
export * from "./video-placeholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__